import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';
import { CompanyAccessInfo, IPet, ISelfResponse } from '@/shared/interfaces';
import { ProfileRouter } from './ProfileRouter';
import {
    CouponRedemptionViewModel,
    InsurancePartnerBenefit,
    InsurancePartnerOption,
    PfaProgressCard,
    TrainingProgramViewModel,
} from '@/features/profile/model/types';
import { SubscriptionDetailsResponse } from '@/features/profile/model/types';
import type { LanguageCode } from '@/shared/enums';

export type ProfileAppProps = {
    selfResponse: ISelfResponse;
    pets: IPet[];
    canInviteHouseholdMembers: boolean;
    adultHouseholdMemberTerms: string;
    childTerms: string;
    isAdolescentEnabled: boolean;
    adolescentMinimumAge: number;
    adultMinimumAge: number;
    isMarketingAccepted: boolean;
    email: string;
    isTopdanmark: boolean;
    showSubscriptionWarning: boolean;
    showAdolescentWarning: boolean;
    isAdolescent: boolean;
    hasVeterinarianCoverage: boolean;
    companyAccessInfo: CompanyAccessInfo;
    publicInsurancePartners: InsurancePartnerOption[];
    insurancePartnerBenefits: InsurancePartnerBenefit[];
    pfaProgressCards: PfaProgressCard[];
    couponRedemptions: CouponRedemptionViewModel[];
    trainingPrograms: TrainingProgramViewModel[];
    subscriptions: SubscriptionDetailsResponse[];
    supportedLanguages: LanguageCode[];
    currentLanguage: LanguageCode;
};

export function ProfileApp(
    containerQuery: string,
    profileAppProps: ProfileAppProps,
) {
    const container = document.querySelector(containerQuery);
    if (!container) return;

    const queryClient = new QueryClient();
    createRoot(container).render(
        <QueryClientProvider client={queryClient}>
            <ProfileRouter {...profileAppProps} />
        </QueryClientProvider>,
    );
}
